import React from 'react';
import { AlertTriangle, CheckCircle, AlertCircle } from 'lucide-react';

export const SyncStatusBadge = ({ trademark, className = '' }) => {
    const getSyncState = (tm) => {
        if (!tm.last_sync_at) return { status: 'never', label: 'Nunca', color: 'text-gray-500' };

        // Si tiene cambios pendientes (prioridad)
        if (tm.has_pending_changes) return { status: 'pending', label: 'Cambios', color: 'text-amber-600' };

        // Si hubo error
        if (tm.last_sync_status === 'error') return { status: 'error', label: 'Error', color: 'text-red-600' };

        // Si fue warning (ej. timeout tramites)
        if (tm.last_sync_status === 'warning') return { status: 'warning', label: 'Parcial', color: 'text-orange-600' };

        // Success / No changes
        return { status: 'success', label: 'Actualizado', color: 'text-emerald-600' };
    };

    const formatLastSync = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        // Formato compacto: "24-ene 12:42"
        const day = date.getDate();
        const month = date.toLocaleString('es-MX', { month: 'short' }).replace('.', '');
        const time = date.toLocaleString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: false });
        return `${day}-${month} ${time}`;
    };

    const state = getSyncState(trademark);

    return (
        <div className={`flex flex-col items-start ${className}`}>
            {/* Compact Line: Icon + Status */}
            <div className={`flex items-center gap-1 text-xs font-medium ${state.color}`}>
                {state.status === 'success' && <CheckCircle className="h-3 w-3" />}
                {state.status === 'error' && <AlertCircle className="h-3 w-3" />}
                {state.status === 'pending' && <AlertTriangle className="h-3 w-3" />}
                {state.status === 'warning' && <AlertTriangle className="h-3 w-3" />}
                <span>{state.label}</span>
            </div>

            {/* Date below */}
            {trademark.last_sync_at && (
                <span className="text-[10px] text-gray-400 pl-4 leading-none" title={`Error: ${trademark.last_sync_error || 'Ninguno'}`}>
                    {formatLastSync(trademark.last_sync_at)}
                </span>
            )}
        </div>
    );
};
